import React from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import styled from '@emotion/styled';

interface TitleModalProps {
  title: string;
  explain?: string;
  isBtnBack?: boolean;
  onClick?: () => void;
}

export const TitleModal = (props: TitleModalProps) => {
  return (
    <StyledWrapper>
      {props.isBtnBack && (
        <Button type="default" icon={<ArrowLeftOutlined />} size="large" onClick={props.onClick && props.onClick} />
      )}
      <div className="title-span">
        <span className="title-primary">{props.title}</span>
        {props.explain && <span className="explain-title">{props.explain}</span>}
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  display: flex;

  & .title-span {
    display: grid;
    margin-left: 0.8rem;
    & > .title-primary {
      font-size: 24px;
    }

    & > .explain-title {
      font-size: 14px;
      color: #5a5a5a;
      margin-top: 5px;
      font-weight: normal;
      margin-bottom: -10px;
    }
  }
`;
